import { createContext } from 'react';
var defaultFormFunctions = { setOnSave: function () { } };
var FormContext = createContext(defaultFormFunctions);
FormContext.displayName = 'FormContext';
export default FormContext;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/form/FormContext.js
// module id = 430
// module chunks = 0